import React from 'react';
import connect from 'Shared/connect';
import Main from 'Shared/PageLayout';
import { Checkbox } from 'Shared/Fields';
import { translate } from 'Shared/translate';
import { epiPropertyValue, EpiProperty } from '@avensia/nitro5-scope-episerver';
import * as styles from './base.scss';
class InfoModalComponent extends React.Component {
    toggleHideModal(checked) {
        let pageId = checked ? epiPropertyValue(this.props.workId) : '-1';
        let now = new Date();
        now.setTime(now.getTime() + 1 * 3600 * 1000);
        document.cookie = 'hideInfoModal=' + pageId + '; expires=' + now.toUTCString() + '; path=/;SameSite=None;secure';
    }
    render() {
        return (React.createElement(Main, { appearance: "narrow" },
            React.createElement("h1", null,
                React.createElement(EpiProperty, { for: this.props.name })),
            React.createElement("div", null,
                React.createElement(EpiProperty, { for: this.props.mainBody })),
            React.createElement("div", { className: styles.right },
                React.createElement("div", null,
                    React.createElement(Checkbox, { onChange: e => this.toggleHideModal(e.target.checked) }, translate('/Shared/DontShowAgain'))))));
    }
}
export default connect(state => ({
    currentUser: state.currentUser,
}))(InfoModalComponent);
